type SalesCalloutAlternateProps = {
  headline: string;
  image: JSX.Element;
  cta?: JSX.Element;
};

type Props = React.ComponentPropsWithoutRef<'div'> & SalesCalloutAlternateProps;

const SalesCalloutAlternateNew = ({ className, children, headline, image, cta, ...props }: Props) => {
  return (
    <div className={`flex flex-col ${className ? className : ''}`}>
      <h3 className="text-h4 mb-16">{headline}</h3>

      <div className="mb-32">{image}</div>

      {children && <div className="hyphens flex-grow break-words">{children}</div>}

      {cta && cta}
    </div>
  );
};

export default SalesCalloutAlternateNew;
